module.exports = __webpack_public_path__ + "88bb2f6f4d12ea9406f4688b14b9af7e.svg";